var iquicker_version = "1.1.3";

moment.locale('zh-cn');
var old_browser = {};
old_browser.Chrome=false;
old_browser.Firefox=false;
old_browser.Safari=false;
if(/msie (9|10)\.0;/.test(navigator.userAgent.toLowerCase())){
	var agent = navigator.userAgent.toLowerCase();
	var m = agent.match(/msie (9|10)\.0;/);
	old_browser.version = m[1];
	old_browser.IE = true;
	$("body").addClass("ie");
	if(!window.console){
		window.console = {
			log:function(){},
			debug:function(){},
			error:function(){}
		}
	}
}else if(/msie/.test(navigator.userAgent.toLowerCase())){
	alert("抱歉我们不对IE8及以下浏览器作支持，如IE高级版本浏览器，请关闭兼容模式打开")
}else if(/Trident/.test(navigator.userAgent)){
	old_browser.IE = true;
	old_browser.version = 11;
	$("body").addClass("ie");
}else if(/Edge/.test(navigator.userAgent.toLowerCase())){
	old_browser.IE = true;
	old_browser.version = "Edge";
	$("body").addClass("ie");
}else if(/Chrome/.test(navigator.userAgent)){
	old_browser.Chrome = true;
	old_browser.version = "Chrome";
}else if(/Firefox/.test(navigator.userAgent)){
	old_browser.Firefox = true;
	old_browser.version = "Firefox";
}else if(/Safari/.test(navigator.userAgent)){
	old_browser.Safari = true;
	old_browser.version = "Safari";
}

(function(){
	
	var $window = $(window);
	// $(document).ready(function (e) {
	// 	$("body").addClass("header-zipped");
	// })
	$window.bind("load resize scroll",function(){
		// 兼容性FIX
		if($window.scrollTop() > 1){
			$("body").addClass("header-zipped");
		}
		else{
			$("body").removeClass("header-zipped");
		}
	})
	$window.bind("load resize", function() {
	    if ($(this).width() < 769) {
	        $('body').addClass('body-small')
	    } else {
	        $('body').removeClass('body-small')
	    }
	})

	// 弹出modal时，禁用滚轮事件
	var $body = $('body');
	$window.on('mousewheel.prevent-modalaa', function (event) {
		if($(event.target).closest('.modal-dialog').length) {
	      event.stopPropagation();
	    } else {
	      if ($(event.target).closest('.mymodal').length) {
	    	  event.preventDefault();
	      }
	    }
	});
})()

var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var base64DecodeChars = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
		-1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
		16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1,
		-1, -1, -1, -1);

function base64Encode(toEncode) {
	var out, i, len;
	var c1, c2, c3;
	len = toEncode.length;
	i = 0;
	out = "";

	while (i < len) {
		c1 = toEncode.charCodeAt(i++) & 0xff;

		if (i == len) {
			out += base64EncodeChars.charAt(c1 >> 2);
			out += base64EncodeChars.charAt((c1 & 0x3) << 4);
			out += "==";
			break
		}

		c2 = toEncode.charCodeAt(i++);

		if (i == len) {
			out += base64EncodeChars.charAt(c1 >> 2);
			out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
			out += base64EncodeChars.charAt((c2 & 0xF) << 2);
			out += "=";
			break
		}

		c3 = toEncode.charCodeAt(i++);
		out += base64EncodeChars.charAt(c1 >> 2);
		out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
		out += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
		out += base64EncodeChars.charAt(c3 & 0x3F)
	}

	return out
}

function base64Decode(toDecode) {
	var c1, c2, c3, c4;
	var i, len, out;
	len = toDecode.length;
	i = 0;
	out = "";

	while (i < len) {
		do {
			c1 = base64DecodeChars[toDecode.charCodeAt(i++) & 0xff]
		} while (i < len && c1 == -1);

		if (c1 == -1)
			break;

		do {
			c2 = base64DecodeChars[toDecode.charCodeAt(i++) & 0xff]
		} while (i < len && c2 == -1);

		if (c2 == -1)
			break;

		out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));

		do {
			c3 = toDecode.charCodeAt(i++) & 0xff;

			if (c3 == 61)
				return out;

			c3 = base64DecodeChars[c3]
		} while (i < len && c3 == -1);

		if (c3 == -1)
			break;

		out += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));

		do {
			c4 = toDecode.charCodeAt(i++) & 0xff;

			if (c4 == 61)
				return out;

			c4 = base64DecodeChars[c4]
		} while (i < len && c4 == -1);

		if (c4 == -1)
			break;

		out += String.fromCharCode(((c3 & 0x03) << 6) | c4)
	}

	return out
}
//去重
function removeRepeat(list){
	var len = list.length;
	for(var i = 1,n = 1;i<len; i++,n++){
		var flag = false;
		for(var j = n-1;j>=0 && !flag;j--){
			var t0 = list[j];
			var t1 = list[i];
			if(list[j] == list[i]){
				flag = true;
			}
		}
		if(flag){//如果第i个在之前出现过n停留当前位置，即n--
			n--;
		}
		else{//如果i没出现过，重新赋值
			list[n] = list[i];
		}
	}
	list.length = n;
	return list;
}

//去除数组中的某个元素
function removeElement(list, obj){
	var i=0,j=0;
	for(; i<list.length; i++,j++){
		list[j] = list[i];
		if(list[i] == obj){
			j--;
		}
	}
	list.length = j;
	return list;
}
//按照下标去除数组中的某个元素
function removeElementByIndex(list, i){
	if(list && list.length>0){
		for(var _i=0,j=0; _i<list.length; _i++,j++){
			list[j] = list[_i];
			if(i==_i){
				j--;
			}
		}
		list.length = list.length-1;
	}
	return list;
}
//字符串长度判断
function getLength(str){
	if(str){
		var realLength = 0,len = str.length;
		for(var i=0;i<len;i++){
			var charCode = str.charCodeAt(i);
			if (charCode >= 0 && charCode <= 128) {
				realLength += 1;
			}else {
				realLength += 2;
			}
		}
		return realLength;
	}
}
//获取两个字符串之间的内容
function getInnerStr(sourceStr, startStr, endStr) {
	var startIndex = sourceStr.indexOf(startStr);
    var endIndex = sourceStr.lastIndexOf(endStr);
    var retStr = sourceStr.substring(startIndex+startStr.length, endIndex);
    return retStr;
}
//数字、字符串 转时间 数字是date.getTime 字符串要求 yyyy-MM-dd HH:mm:ss格式 Hms可选
function parseDate(_input){
	if(typeof _input == undefined){
		//如果 是undefined
		return new Date();
	}

	return moment(_input).toDate();
    throw("parseDate error");
    return new Date();
}
/*******************查询结果匹配****************************/
var CIAPP = CIAPP || {};

CIAPP.namespace = function (ns_string) {
    var parts = ns_string.split('.'),
    parent = CIAPP,
    i;

    //剥离最前面的冗余全局变量
    if(parts[0] === 'CIAPP'){
        parts = parts.slice(1);
    }
    for(i = 0, len = parts.length; i < len; i +=1){
        if(typeof parent[parts[i]] === "undefined"){
            parent[parts[i]] = {};
        }
        parent = parent[parts[i]];
    }
    return parent;
};


CIAPP.namespace('CIAPP.utils.changeColor');


CIAPP.utils.changeColor = (function(){

    //private property
    var doc =  document,
    changeCon,
    changeClass,
    changeStr,
    children,
    pattern,
    newString,

    traversal = function(children) {
        var i, len;

        for(i = 0, len = children.length; i < len; i += 1) {
            newNodeText = '';

            if(children[i].children){
                traversal(children[i].childNodes);
            }

            //文本内容部分
            if(children[i].nodeType === 3 ){

                pattern = new RegExp( changeStr, "g" );

                newString = children[i].nodeValue.replace( pattern
                            , "<em class="+changeClass+">"+ changeStr +"</em>");


                // 如果匹配指定字符串
               if( pattern.test( children[i].nodeValue ) ){
                thisNode = children[i];
                children[i].parentNode.innerHTML = newString;

                }
            }
    

        }
    },

    init = function(classname, class_chg, str){
        changeCon = doc.getElementsByClassName(classname),
        changeClass = class_chg;
        changeStr = str;
        
        for( var i = 0, len = changeCon.length; i < len; i += 1){
        	children = changeCon[i].childNodes;
        	traversal(children);
        }
    };

    return {
        init : init,
        change : traversal
    }

}());

